import axios from "axios";
import {USER_VERIFY_URL} from '../config/links'
import {toast} from 'react-toastify'

export const FETCH_USER_VERIFY = 'FETCH_USER_VERIFY'
export const RECEIVE_USER_VERIFY = 'RECEIVE_USER_VERIFY'
export const FAILED_USER_VERIFY = 'FAILED_USER_VERIFY'

export function userVerification(authToken){
    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_USER_VERIFY});
        axios({
            method: 'post',
            url: USER_VERIFY_URL+"/"+authToken,
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_USER_VERIFY,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_USER_VERIFY
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_USER_VERIFY
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_USER_VERIFY
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_USER_VERIFY
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_USER_VERIFY
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_USER_VERIFY
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}